/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demo_Refused_ImportInputs */



/**
* | output |
* | --- |
* | "Level and history imports aren't available in the demo." |
*
* @param {Demo_Refused_ImportInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const demo_refused_import = /** @type {((inputs?: Demo_Refused_ImportInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demo_Refused_ImportInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт уровней и истории в демо недоступен.")
	return /** @type {LocalizedString} */ ("Level and history imports aren't available in the demo.")
});